import { BRAND_CONSTANTS, type TProduct } from "@lexicanon/shared"
import type { I18n } from "@lingui/core"
import { msg } from "@lingui/core/macro"

interface IProductLabels {
  name: string
  tagline: string
  meeting: string
  meetings: string
  session: string
  startAction: string
}

/**
 * Per-product UI vocabulary. `name` / `tagline` are brand identity (from the
 * shared `BRAND_CONSTANTS` SSOT — the same strings the manifest + /api/product
 * serve). The remaining labels are user-facing UI nouns/verbs that MUST follow
 * the app locale, so they are Lingui `msg` descriptors resolved with the active
 * `i18n` (the codebase pattern, mirroring `lib/meeting-title.ts`). Previously
 * these returned raw English and leaked untranslated into three components.
 */
export function getLabels(i18n: I18n, product: TProduct): IProductLabels {
  const brand = BRAND_CONSTANTS[product]
  if (product === "voxcanon") {
    return {
      name: brand.name,
      tagline: brand.tagline,
      meeting: i18n._(msg`Session`),
      meetings: i18n._(msg`Sessions`),
      session: i18n._(msg`Session`),
      startAction: i18n._(msg`Begin session`),
    }
  }
  return {
    name: brand.name,
    tagline: brand.tagline,
    meeting: i18n._(msg`Meeting`),
    meetings: i18n._(msg`Meetings`),
    session: i18n._(msg`Meeting`),
    startAction: i18n._(msg`Start meeting`),
  }
}
